module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column justify-content-end h-100"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Enter a reference to add to the selection:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col pr-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemSearchTerm),
      expression: "itemSearchTerm"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.itemSearchTerm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.newSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemSearchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('ForcastButton', {
    attrs: {
      "size": 'l',
      "disabled": !_vm.itemSearchTerm
    },
    on: {
      "click": _vm.newSearch
    }
  }, [_vm._v("Add it")])], 1)])]), _vm._v(" "), (_vm.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "size": "xl",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.isActive = false
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.total !== null) ? _c('div', {
    staticClass: "row result"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "number-of-items"
  }, [_c('span', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" items found\n                        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row item-select align-items-center"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    style: ({
      visibility: _vm.currentPage > 1 ? 'visible' : 'hidden'
    }),
    on: {
      "click": function($event) {
        _vm.currentPage--
      }
    }
  }, [_c('ForcastButton', [_vm._v("Prev")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inner row"
  }, _vm._l((_vm.paginatedItems), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col"
    }, [_c('ItemSearchSingle', {
      attrs: {
        "item": item,
        "disabled": !_vm.canAddItem(item),
        "forecast-windows": _vm.forecastWindows
      },
      on: {
        "item-added": function($event) {
          _vm.addItem(item)
        }
      }
    })], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    style: ({
      visibility: _vm.hasNextPage ? 'visible' : 'hidden'
    })
  }, [_c('ForcastButton', {
    on: {
      "click": _vm.goToNextPage
    }
  }, [_vm._v("View"), _c('br'), _vm._v("more"), _c('br'), _vm._v("results")])], 1)])])])], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2823d98c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/itemSearch/ItemSearch.vue
// module id = 3089
// module chunks = 0